import { useState } from 'react';
import { TableInput } from '../../../components/common';

interface IProps {
  spcData: any;
}
const TBody = ({ spcData }: IProps) => {
  const [_, setRender] = useState(false);

  const tableRows = Array.from(
    { length: Math.floor(spcData.spc_array.length / 10) },
    (_, rowIdx) => (
      <tr key={rowIdx + 'spc_row'}>
        <td>{rowIdx + 1}</td>
        {spcData.spc_array
          .slice(rowIdx * 10, (rowIdx + 1) * 10)
          .map((_: any, spcidx: any) => (
            <td
              key={spcidx + rowIdx * 10}
              style={{ backgroundColor: '#fff3bf' }}
            >
              <TableInput
                name="remarks"
                type="number"
                isView={false}
                style={{ width: '100px', backgroundColor: '#fff3bf' }}
                value={spcData.spc_array[spcidx + rowIdx * 10]}
                onChange={(e) => {
                  spcData.spc_array[spcidx + rowIdx * 10] =
                    e.target.valueAsNumber;
                  setRender((prev) => !prev);
                }}
              />
            </td>
          ))}
      </tr>
    ),
  );
  return <tbody>{tableRows}</tbody>;
};

export default TBody;
